import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getVehicleInventorySorting } from '../../../reducers/compoundManagementSlice';
import { AppTableCardsSorting } from '../../../sharedComponents/table/AppTableCardsSorting';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { Table } from '../../../sharedComponents/table/Table';
import { useSelectedTableColumns } from '../../../sharedComponents/table/useSelectedTableColumns';
import { InventoryVehicle } from '../../compoundManagement.types';
import { CompoundManagementTableRow } from '../../shared/table/CompoundManagementTableRow';
import { InventorySelectionCell } from './InventorySelectionCell';
import { VehicleInventoryBulkSelectionDropdown } from './VehicleInventoryBulkSelectionDropdown';
import { VehicleInventoryTableColumn } from './VehicleInventoryTableColumn';
import { VehicleInventoryTableDataContent } from './VehicleInventoryTableDataContent';

type VehicleInventoryTableProps = {
    readonly vehicles: readonly InventoryVehicle[];
};

export const VehicleInventoryTable = ({ vehicles }: VehicleInventoryTableProps) => {
    const sorting = useAppSelector(getVehicleInventorySorting);
    const dispatch = useAppDispatch();

    const setSorting = (newSorting: TableSort<VehicleInventoryTableColumn>) =>
        dispatch(compoundManagementSlice.actions.setInventorySorting(newSorting));

    const columnDefinition = useSelectedTableColumns<VehicleInventoryTableColumn>();

    return (
        <>
            <AppTableCardsSorting columnDefinition={columnDefinition} sorting={sorting} setSorting={setSorting} />
            <Table
                columnDefinition={columnDefinition}
                sorting={sorting}
                setSorting={setSorting}
                items={vehicles}
                notFoundMessage={
                    <FormattedMessage id="outboundOrderBook.compoundManagement.vehicleInventory.notFound" />
                }
                selectionHeader={<VehicleInventoryBulkSelectionDropdown />}
            >
                {vehicles.map((vehicle: InventoryVehicle) => (
                    <CompoundManagementTableRow
                        key={vehicle.id}
                        highlight={vehicle.arrival.isCancelled ? 'danger' : undefined}
                        columnDefinition={columnDefinition}
                        vehicle={vehicle}
                        selectionCell={<InventorySelectionCell vehicleId={vehicle.id} />}
                    >
                        {(column) => <VehicleInventoryTableDataContent column={column} vehicle={vehicle} />}
                    </CompoundManagementTableRow>
                ))}
            </Table>
        </>
    );
};
